"use strict";

var Reflux = require("reflux");

var ValidationActions = {
    validateAllFields: Reflux.createAction({ sync: true }),
    forceValidateFields: Reflux.createAction({ async: true })
};

module.exports = ValidationActions;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-validation/lib/js/actions/ValidationActions.js
// module id = 500
// module chunks = 93